<template>
    <rd-card type="vertical" margins="none">
        <rd-card-header>
            <rd-header :title="$t('dashboard.valuesByDepartmentAndType.title')" margins="none" size="medium">
                <dx-drop-down-box :data-source="departments"
                                  display-expr="Text"
                                  value-expr="Value"
                                  :placeholder="$t('dashboard.valuesByOrderType.choose')"
                                  :value.sync="departmentsValue"
                                  @value-changed="changeDepartment">
                    <template #content="{ data }">
                        <dx-list :data-source="departments"
                                 display-expr="Text"
                                 key-expr="Value"
                                 :show-selection-controls="true"
                                 page-load-mode="scrollBottom"
                                 selection-mode="all"
                                 :selected-item-keys="getDepartmentsValues"
                                 @selection-changed="departmentSelectionChange" />
                    </template>
                </dx-drop-down-box>
            </rd-header>
        </rd-card-header>
        <rd-card-content>
            <dx-chart :data-source="valuesByOrderTypeDataSource"
                      :series="seriesSettings"
                      :legend="{ visible: false }"
                      :loadingIndicator="{ enabled: true }"
                      :argument-axis="argumentSettings"
                      ref="valuesByOrderTypeChart">
                <dx-tooltip :enabled="true"
                            :format="{ type: 'fixedPoint', precision: 2}"
                            location="edge" />
            </dx-chart>
        </rd-card-content>
    </rd-card>
</template>

<script>
    // @ is an alias to /src
    import { mapState, mapActions, mapGetters } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import DxDropDownBox from "devextreme-vue/drop-down-box";
    import DxList from "devextreme-vue/list";
    import { DxChart, DxTooltip } from 'devextreme-vue/chart';

    const name = "processesStores/pzzDashboardStores/indexStore";

    export default {
        name: 'pzzDashboardValyesByOrderType',
        created() {
            this.setDepartments();
            this.setDepartmentsLoaded(() => {
                this.departmentsValue = this.getDepartmentsValues;
                this.setValuesByOrderTypeDataSource();
            })
        },
        data() {
            return {
                seriesSettings: {
                    type: 'bar',
                    argumentField: 'OrderType',
                    valueField: 'GrossSummary',
                    aggregation: {
                        enabled: true,
                        method: 'sum'
                    }
                },
                argumentSettings: {
                    label: {
                        overlappingBehavior: 'ignore',
                        rotationAngle: 45,
                        displayMode: 'rotate',
                        font: {
                            size: 10
                        }
                    },
                    aggregateByCategory: true
                },
                departmentsValue: null
            }
        },
        computed: {
            ...mapState(name, ['valuesByOrderTypeDataSource', 'departments']),
            ...mapGetters(name, ['getDepartmentsValues']),
            chartInstance() {
                return this.$refs.valuesByOrderTypeChart.instance;
            }
        },
        methods: {
            ...mapActions(name, ['setValuesByOrderTypeDataSource', 'setDepartments', 'setDepartmentsLoaded']),
            changeDepartment(e) {
                let chartDataSource = this.chartInstance.getDataSource()
                if (e.value.length && e.value.length != this.departments.length) {
                    let filterExpr = e.value.map((value) => ['DepartmentId', '=', value]).insertBetween('OR');
                    chartDataSource.filter(filterExpr);
                } else
                    chartDataSource.filter([]);

                chartDataSource.reload();
            },
            departmentSelectionChange(e) {
                this.departmentsValue = e.component.option('selectedItemKeys');
            }
        },
        components: {
            DxChart,
            DxTooltip,
            DxDropDownBox,
            DxList
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
